// Кликабельные карточки: клик в любом месте карточки ведёт туда же, куда её кнопка "Подробнее".
// Клики по ссылкам и кнопкам внутри карточки не перехватываем.
document.addEventListener('DOMContentLoaded', function() {
    function go(url, target) {
        if (!url || url === '#') return;
        if (target === '_blank') window.open(url, '_blank', 'noopener');
        else window.location.href = url;
    }

    function bind(card, getUrl, getTarget) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', function(e) {
            if (e.target.closest('a, button')) return;
            // Пользователь выделяет текст — это не клик по карточке
            if (String(window.getSelection())) return;
            go(getUrl(), getTarget ? getTarget() : '');
        });
    }

    // Карточки с явной ссылкой (блоки "Чем заняться" и "Сделайте ваш отдых особенным")
    document.querySelectorAll('[data-card-href]').forEach(function(card) {
        bind(card, function() { return card.getAttribute('data-card-href'); }, function() { return card.getAttribute('data-card-target'); });
    });

    // Карточки отелей: у отелей со ссылкой в Самотур переход уже обрабатывает Hotels.js
    document.querySelectorAll('.hotel-card:not([data-samo-url])').forEach(function(card) {
        const btn = card.querySelector('a.hotel-select-btn');
        if (!btn) return;
        bind(card, function() { return btn.getAttribute('href'); });
    });
});
